import { AxiosUtilsType, axiosGet } from './axiosUtils';
import './axiosInterceptor';

const PinService = {
  async getPinList(): AxiosUtilsType {
    return await axiosGet(`pin/list`);
  },
};
export default PinService;
